module.exports = "/static/assets/1ea1995d98c06794b17b4dcfe6d13849.png";